import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import type { BenchmarkRubric } from './benchmarkRubrics';

const rubricRows = ({ variant }: BenchmarkRubric) =>
  variant.kind === 'by-level'
    ? variant.criteria.map((row) => ({
        dimension: row.dimension?.name,
        level: row.level,
        criteria: row.criteria_text,
      }))
    : variant.standards.map((standard) => ({
        dimension: standard.dimension_name,
        track: standard.careerTrack?.name,
        standard: standard.standard_text,
      }));

const rubricScope = ({ variant }: BenchmarkRubric) =>
  variant.kind === 'by-level' ? variant.gradeLabel : variant.tenureLabel;

export const useAgentContext = (rubric: BenchmarkRubric | undefined) => {
  useRegisterAgentContext(
    rubric
      ? {
          kind: 'visual',
          label: `${rubric.category.name} rubric — ${rubricScope(rubric)}`,
          display:
            'One Are You on Track rubric table, picked with the Unlock and Year dropdowns. Academic Foundations shows the standards for each career track across high school or college; the other three categories show the Proficient and Advanced criteria for the chosen year.',
          data: {
            category: rubric.category.name,
            scope: rubricScope(rubric),
            rows: rubricRows(rubric),
          },
        }
      : null,
  );
};
